import GaugeComponent from 'react-gauge-component';

import { ColorsRaw } from '@/ui/theme/colors-raw';

type Props = {
  score: number;
  maxScore?: number;
};

export function LittleGauge({ score, maxScore }: Props) {
  const percentage = maxScore ? (score / maxScore) * 100 : 100;
  const colorArray = [getColorFromPercentage(percentage), '#ccc'];
  const subArcs = [{ length: percentage / 100 }, { limit: 100 }];
  return (
    <div style={{ width: '90px', marginLeft: '20px', marginTop: '0px' }}>
      <GaugeComponent
        value={100}
        type="semicircle"
        labels={{
          valueLabel: {
            hide: true,
          },
          tickLabels: {
            type: 'outer',
            ticks: [],
            hideMinMax: true,
            defaultTickValueConfig: {
              formatTextValue: (value: number) => `${value}`,
            },
          },
        }}
        arc={{
          colorArray,
          subArcs,
          padding: 0,
          width: 0.11,
          cornerRadius: 4,
        }}
        pointer={{
          hide: true,
        }}
      />
    </div>
  );
}

function getColorFromPercentage(percentage: number) {
  if (percentage < 20) {
    return ColorsRaw.scores.Pink;
  } else if (percentage < 40) {
    return ColorsRaw.scores.Orange;
  } else if (percentage < 60) {
    return ColorsRaw.scores.Mandarine;
  } else if (percentage < 80) {
    return ColorsRaw.scores.Lime;
  } else {
    return ColorsRaw.scores.Green;
  }
}
